import { mergeApis, Zodios } from "@zodios/core";
import qs from "qs";

import { normalizeAxiosError } from "@/api/api-error-normalization.ts";
import { gouvAddressSearchApi } from "@/api/gouv/search/gouv-address-search-api.ts";
import { loadDeprecatedEnv } from "@/env.deprecated.ts";

const GouvAddressApiDefinition = mergeApis({
  "/search": gouvAddressSearchApi,
});

const GouvAddressApi = new Zodios(loadDeprecatedEnv().VITE_GOUV_ADDRESS_BASE_URL, GouvAddressApiDefinition, {
  axiosConfig: {
    paramsSerializer: {
      serialize: (params) => qs.stringify(params, { arrayFormat: "comma" }),
    },
  },
});

GouvAddressApi.axios.interceptors.response.use(undefined, (error) => {
  throw normalizeAxiosError(error, "api-gouv");
});

export default GouvAddressApi;
